import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Adjuntos } from '../models/adjuntos';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Adjuntos';

@Injectable({
  providedIn: 'root'
})
export class AdjuntosService {

  constructor(private _http: HttpClientService) { }

  getById(id: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetById?id=' + id })
  }

  save(imagen: Adjuntos)
  {
    return this._http.post({ url: baseUrl + '/Save', body: imagen });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getByTabla(tabla, tablaId): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetByTabla?tabla='+ tabla + '&tablaId=' + tablaId })
  }
}

